<template>
  <div>
    <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-button type="primary" icon="plus" @click="addActivityData">添加活动</el-button>
          </el-col>
        </el-row>
      <el-tabs type="border-card" v-model="activitycate" @tab-click="handleClick">
        <el-tab-pane label="全部" name="0"></el-tab-pane>
        <el-tab-pane label="社群分享" name="1"></el-tab-pane>
        <el-tab-pane label="限量团购" name="2"></el-tab-pane>
        <el-tab-pane label="会员升级" name="3"></el-tab-pane>
        <el-tab-pane label="赠品活动" name="4"></el-tab-pane>
        <el-tab-pane label="素材分享" name="5"></el-tab-pane>
        <el-table :data="activityList" :height="wheight-210"  v-loading="loading"  @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" label="全选"></el-table-column>
<!--          <el-table-column prop="act_id" label="ID" width="130"></el-table-column>-->
          <el-table-column label="图片" width="100">
            <template slot-scope="scope">
              <el-popover placement="right" width="240" trigger="hover" >
                <img :src="scope.row.img" style="width:100%;">
                <el-button type="text" slot="reference"><img style="width:50px;height:50px;" :src="scope.row.img"></el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" width="130"></el-table-column>
          <el-table-column label="活动时间" width="190">
            <template slot-scope="scope">
              {{scope.row.start_date}} <span class="text-muted">开始</span>
              {{scope.row.end_date}} <span class="text-muted">结束</span>
            </template>
          </el-table-column>
<!--          <el-table-column prop="act_sort" label="活动排序" width="130"></el-table-column>-->
          <el-table-column prop="act_sort" label="活动排序" width="80">
            <template slot-scope="scope">
              <input v-model="scope.row.act_sort"  @change="sortEdit(node, scope.row)" style="width: 50px;border: 1px solid #ddd;line-height: 25px;padding-left: 5px;"/>
            </template>
          </el-table-column>
          <el-table-column prop="activitycate" label="活动分类" width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.activitycate=='1'">社群分享</span>
              <span v-else-if="scope.row.activitycate=='2'">限量团购</span>
              <span v-else-if="scope.row.activitycate=='3'">会员升级</span>
              <span v-else-if="scope.row.activitycate=='4'">赠品活动</span>
              <span v-else>素材分享</span>
            </template>
          </el-table-column>
          <el-table-column prop="sku_bns" label="货号" width="200"></el-table-column>
          <el-table-column prop="items" label="商品" width="50">
            <template slot-scope="scope">
              <div class="operating-icons custom-icons">
                <i class="iconfont icon-search-plus" @click="viewGoodsList(scope.row.act_id)"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="created_date" label="创建时间" width="160"></el-table-column>
          <el-table-column label="操作" width="130">
            <template slot-scope="scope">
              <el-button type="text" @click="editCommunityAction(scope.$index, scope.row)" class="btn-gap">编辑</el-button>
              <el-popover
                placement="right"
                width="450"
                trigger="hover">
                <div class="operating-icons">
<!--                  <el-button type="text"  @click="copyAction(scope.$index,scope.row)">复制活动</el-button>-->
                  <el-button type="text" @click="deleteItemsAction(scope.$index, scope.row)" class="btn-gap">删除</el-button>
                </div>
                <el-button type="text" slot="reference"><i class="iconfont icon-angle-double-right"></i></el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </el-tabs>
        <div v-if="total_count > params.pageSize" class="content-padded tc">
          <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
          </el-pagination>
        </div>

        <el-dialog title="活动商品列表" :visible.sync="goodsVisible" :before-close="handleCancel" width="70%">
          <template>
            <el-table :data="goodsList" v-loading="loading">
              <el-table-column prop="sku_id" label="商品ID" width="80"></el-table-column>
              <el-table-column prop="sku_bn" label="商品货号" width="80"></el-table-column>
              <el-table-column prop="sku_name" label="商品名称"></el-table-column>
              <el-table-column prop="max_sell" label="限量团购" width="50"></el-table-column>
              <el-table-column prop="act_sort" label="排序" width="50"></el-table-column>
            </el-table>
            <div v-if="goodsCount > goodsPageSize" class="content-center content-top-padded">
              <el-pagination
                layout="prev, pager, next"
                @current-change="handleGoodsCurrentChange"
                :current-page.sync="goodsPage"
                :total="goodsCount" :page-size="goodsPageSize">
              </el-pagination>
            </div>
          </template>
        </el-dialog>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {activityList, deleteItems, getActivityhotList, activitySortEdit} from '../../../api/sharer'
import Style from "../../pc/footerPage/components/plugins/footer/style";
import {mapGetters} from "vuex";
export default {
  components: {Style},
  provide () {
    return {
      refresh: this.refresh
    }
  },
  data () {
    return {
      total_count: 0,
      loading: false,
      activityList: [],
      activitycate: 0,
      params: {
        page: 1,
        pageSize: 20
      },
      goodsVisible: false,
      goodsList: [],
      goodsCount: 0,
      goodsPageSize: 10,
      goodsPage: 1
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getActivity (filter) {
      this.loading = true
      activityList(filter).then(response => {
        this.activityList = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
    // 切换tab
    handleClick (tab, event) {
      this.activitycate = tab.name
      this.params.activitycate = tab.name
      this.params.page = 1
      this.getActivity(this.params)
    },
    copyAction(index,row){  // 复制活动
      this.$router.push({path: this.matchHidePage('editor/?copy_act_id=') + row.act_id})
    },
    viewGoodsList (activityId) {
      this.nowActivity = activityId
      this.goodsVisible = true
      getActivityhotList({act_id:activityId, page:this.goodsPage, pageSize:this.goodsPageSize}).then(res => {
        let response = res.data.data
        response.list.forEach((item, index) => {
          response.itemTreeLists.forEach((item2, index2) => {
            if (response.itemTreeLists[index2].sku_id == response.list[index].sku_id) {
              response.itemTreeLists[index2].act_sort = item.act_sort
              response.itemTreeLists[index2].max_sell = item.max_sell
            }
          })
        })
        this.goodsList = response.itemTreeLists
        this.goodsCount = response.total_count
      })
    },
    handleCancel () {
      this.goodsVisible = false
    },
    deleteItemsAction (index, row) {
      this.$confirm('此操作将删除该活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteItems(row.act_id).then(response => {
          if (response.data.data && response.data.data.status) {
            this.activityList.splice(index, 1)
            this.$message({
              message: '删除活动成功',
              type: 'success',
              duration: 2 * 1000
            })
          } else {
            this.$message({
              type: 'info',
              message: '删除活动失败'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    addActivityData () { // 添加物料弹框
      this.$router.push({path: this.matchHidePage('editor')})
    },
    editCommunityAction (index, row) { // 编辑物料弹框
      this.$router.push({path: this.matchHidePage('editor/') + row.act_id})
    },
    sortEdit(node, row) {
      let params = {
        'act_id': row.act_id,
        'act_sort': row.act_sort ,
      }
      activitySortEdit(params).then(res => {
        if (res.data.data) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 2 * 1000
          })
          this.getActivity(this.params)
        }
      })
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getActivity(this.params)
    },
    refresh () {
      this.getActivity(this.params)
    }
  },
  mounted () {
    this.getActivity(this.params)
  },
  watch: {
    // 分页全选-监听数据变化
    activityList: {
      handler (value) {
        if (this.allCheck) {
          this.activityList.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style>
.cell{
  max-height: 100px;
  overflow: auto!important;
}
</style>




// WEBPACK FOOTER //
// activity_list.vue?6068d660